import {Platform} from 'react-native';

import {config} from '../config';

/**
 * Returns the base URL for API calls.
 * - Web + proxy enabled: '/api' (relative, handled by webpack proxy)
 * - Otherwise: config.BASE_URL (full URL)
 */
export function getApiBaseUrl(): string {
  if (Platform.OS === 'web' && config.USE_API_PROXY) {
    return '/api';
  }
  return config.BASE_URL;
}
